var $f8e04371a00272fc$exports = {};
$f8e04371a00272fc$exports = {
    "valid": `\u{6709}\u{6548}`
};


export {$f8e04371a00272fc$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
